import { API_URL } from '../../components/common/Constants';
import {
  IStandardAPIResponse,
  IDataCenter,
  ISearchPowerComponent,
  ISearchFloor,
  IFloorVM,
  ISearchMorFloor,
  IQuadrant,
} from '../../vm';
import {
  httpClient,
  handleErrorResp,
  httpFileUpload,
  getToken,
} from '../UtilService';

export async function getAllDataCenters(): Promise<
  IStandardAPIResponse<Array<IDataCenter>>
> {
  try {
    let res = await httpClient<Array<IDataCenter>>(`datacenters`, 'GET');
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function getAllDataCentersOfCustomer(
  customerId: string
): Promise<IStandardAPIResponse<Array<IDataCenter>>> {
  try {
    let res = await httpClient<Array<IDataCenter>>(
      `customer-datacenters`,
      'GET',
      { customerId }
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function searchQuadrantsOfDC(
  datacenterId: string
): Promise<IStandardAPIResponse<Array<IQuadrant>>> {
  try {
    let res = await httpClient<Array<IQuadrant>>(
      `datacenters/${datacenterId}/quadrants`,
      'GET'
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function getADataCenter(
  dataCenterId: string
): Promise<IStandardAPIResponse<IDataCenter>> {
  try {
    let res = await httpClient<IDataCenter>(
      `datacenters/${dataCenterId}`,
      'GET'
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function getPowerComponents(
  obj: ISearchPowerComponent
): Promise<IStandardAPIResponse<Array<any>>> {
  try {
    let res = await httpClient<Array<any>>(`power-components`, 'GET', obj);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function getMorPdus(
  obj: ISearchPowerComponent
): Promise<IStandardAPIResponse<Array<any>>> {
  try {
    let res = await httpClient<Array<any>>(`mor-pdus`, 'GET', obj);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function getFloorsWhichHasUnits(
  obj: ISearchFloor
): Promise<IStandardAPIResponse<Array<IFloorVM>>> {
  try {
    let res = await httpClient<Array<IFloorVM>>(`floors`, 'GET', obj);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function getFloorsWhichHasMorSensors(
  obj: ISearchMorFloor
): Promise<IStandardAPIResponse<Array<IFloorVM>>> {
  try {
    let res = await httpClient<Array<IFloorVM>>(
      `floors-has-mor-sensors`,
      'GET',
      obj
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function fileUpload(
  file: any,
  data: any
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpFileUpload<any>(
      `import-cmt/${data.dataCenterId}`,
      'POST',
      {
        file,
        data,
      }
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function sensorFileUpload(
  file: any,
  data: any
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpFileUpload<any>(
      `import-data-point/${data.dataCenterId}`,
      'POST',
      { file, data }
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function manualImport(obj: {
  importType: string;
  date: Date;
  datacenterId: string;
  file: any;
  pduType?: string;
  accessLogType?: string;
}): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpFileUpload<any>(
      `manual-import?datacenterId=${obj.datacenterId}&importType=${obj.importType}&date=${obj.date}&file=${obj.file}&pduType=${obj.pduType}&accessLogType=${obj.accessLogType}`,
      'POST',
      obj
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getSamplesForManualImport(obj: any): Promise<Response> {
  try {
    const res: any = await fetch(
      `${API_URL}samples-for-manual-import?datacenterId=${obj.datacenterId}&importType=${obj.importType}&pduType=${obj.pduType}&accessLogType=${obj.accessLogType}`,
      {
        method: 'GET',
        credentials: 'include', // Enable credentials for CORS
        headers: { at: getToken() },
      }
    );
    // const res: any = await await httpFileUpload<any>(
    //   `samples-for-manual-import`,
    //   'GET',
    //   data
    // );
    return res;
  } catch (err: any) {
    return err;
  }
}
